<template lang="pug">
  .ai-panel
    .chart-toolbar
      .dropdown-filters
        .dropdown-filter
          segment-select(:customer-segment-filter-options="segmentOptions"
                         is-select-multiple
                         is-select-collapse-tags
                         @change="onSegmentFilterChange")
      .time-range-filter
        aiq-date-picker(v-model="dateRange"
                        type="daterange"
                        placeholder="Select date range"
                        popper-class="metrics-time-range__date-picker-popup"
                        :shortcuts="datePickerOptions.shortcuts"
                        :disabled-date="datePickerOptions.disabledDate"
                        :teleported="false"
                        format="YYYY/MM/DD"
                        :clearable="false"
                        :default-time="getDatePickerDefaultTime()")
    .ai-panel__sections
      aiq-collapse(v-model="openSections")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.overview_tab.title`)" name="overview")
          lynq-ai-overview(v-if="rendered.overview"
                           :date-range="dateRange"
                           :filters="selectedFilters")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.questions_tab.title`)" name="questions")
          smart-assist-questions(v-if="rendered.questions"
                                 :date-range="dateRange"
                                 :filters="selectedFilters"
                                 metric="lynq_ai_faq"
                                 :show-feedback="false")
        aiq-collapse-item(:title="$t(`${I18N_PREFIX}.documents_tab.title`)" name="documents")
          smart-assist-documents(v-if="rendered.documents"
                                 :date-range="dateRange"
                                 :filters="selectedFilters"
                                 metric="lynq_ai_resources"
                                 :show-feedback="false")
</template>

<script>
import { mapGetters } from 'vuex';
import {
  datePickerDefaultOptions,
  defaultDateRange,
  lastAvailableMonthAndQuarterRange,
  createPickerDateRangeOption,
} from '../../configs/dateRange';
import SegmentSelect from '@/components/SegmentsSelect/SegmentsSelect.vue';
import LynqAiOverview from './LynqAIOverview.vue';
import SmartAssistQuestions from './Questions.vue';
import SmartAssistDocuments from './Documents.vue';

const I18N_PREFIX = 'metrics_tab.smart_assist_tab';
const DEFAULT_OPEN = 'overview';

export default {
  name: 'LynqAIMetrics',
  pageResource: '/metrics',
  components: {
    SegmentSelect,
    LynqAiOverview,
    SmartAssistQuestions,
    SmartAssistDocuments,
  },
  data() {
    return {
      I18N_PREFIX,
      // The segment filter and date range are owned here so every section
      // reports on the same window instead of each keeping its own.
      dateRange: defaultDateRange(),
      selectedFilters: [],
      openSections: [DEFAULT_OPEN],
      // Each section fetches its own metrics, so it stays unrendered until first
      // opened. Once rendered it is kept mounted so collapsing does not refetch.
      rendered: { [DEFAULT_OPEN]: true },
    };
  },
  mounted() {
    this.$store.dispatch('configs/getCustomerSegments');
  },
  computed: {
    ...mapGetters({
      segmentOptions: 'configs/segments',
    }),
    datePickerOptions() {
      return {
        ...datePickerDefaultOptions(),
        shortcuts: lastAvailableMonthAndQuarterRange.map(createPickerDateRangeOption),
      };
    },
  },
  watch: {
    openSections(names) {
      names.forEach(name => {
        this.rendered[name] = true;
      });
    },
  },
  methods: {
    onSegmentFilterChange(chosenSegments) {
      const ids = chosenSegments.map(segment => segment.id);
      this.selectedFilters = ids.length ? [{ customer_segments: ids }] : [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./aiPanel.scss";
</style>
